import { render } from "./SideMenuArea.vue?vue&type=template&id=082457f2&scoped=true"
import script from "./SideMenuArea.vue?vue&type=script&lang=js"
export * from "./SideMenuArea.vue?vue&type=script&lang=js"

import "./SideMenuArea.vue?vue&type=style&index=0&id=082457f2&scoped=true&lang=stylus"

import exportComponent from "K:\\ダウンロード\\JASRAC対応\\新しいフォルダー\\東京書籍様_JASRACマーク実装_納品データ\\東京書籍様_JASRACマーク実装_納品データ-最終作業用\\e_5\\e_5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082457f2"]])

export default __exports__